const colorVar = {
  hueGrey: 280,

  base: {
    h: 96,
    s: 44,
    l: 42,
  },

  prim: {
    h: 0,
    s: 100,
    l: 38,
  },

  sec: {
    h: 90,
    s: 30,
    l: 10,
  },
}

export const color = {
  font: "rgba(0, 0, 0, .80)",
  heading: "#ed8282",
  white: "rgba(255, 255, 255, 1)",
  grey: "rgba(0, 0, 0, .50)",
  lightgrey: "rgba(0, 0, 0, .30)",

  base: "#D41F26",
  baseLight: "#ed8282",
  baseDark: "#700000",

  secondary: "#35A6B4",
  secondaryLight: "#35A6B4",
  secondaryDark: "#35A6B4",

  grey1: "rgba(0, 0, 0, .1)",
  grey2: "rgba(0, 0, 0, .2)",
  grey3: "rgba(0, 0, 0, .3)",
  grey4: "rgba(0, 0, 0, .4)",
  grey5: "rgba(0, 0, 0, .5)",
  grey6: "rgba(0, 0, 0, .6)",
}
